import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m17.7 5.275-5-5c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1.1-.2.1-.3.2l-5 5c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.3-3.3v9.6c0 1.7-1.3 3-3 3H1c-.6 0-1 .4-1 1s.4 1 1 1h7c2.8 0 5-2.2 5-5v-9.6l3.3 3.3c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }